<template>
    <div v-if="user.doctor && !consultation.anonym" class="room__userinfo">
        <img :src="patient.avatar" class="room__userphoto avatar" alt="">
        <div class="room__usermeta">
            <span class="room__username">{{ patient.name }}</span>
            <template v-if="consultation.patient.user.deleted_at === null">
                <a v-if="patient.type === 'patient'" :href="`/patient/` + patient.id" target="_blank" class="room__userlink">Показать профиль</a>
                <a v-else :href="`/family/` + patient.id" target="_blank" class="room__userlink">Показать профиль</a>
            </template>
        </div>
    </div>

    <div v-else-if="user.doctor && consultation.anonym" class="room__userinfo">
        <img :src="patient.avatar" class="room__userphoto avatar" alt="">
        <div class="room__usermeta">
            <span class="room__username">{{ patient.name }}</span>
        </div>
    </div>

    <div v-else-if="!user.doctor" class="room__userinfo">
        <img :src="consultation.doctor.user.avatar" class="room__userphoto avatar" alt="">
        <div class="room__usermeta">
            <span class="room__username">{{ consultation.doctor.user.name }}</span>
            <a  v-if="!consultation.doctor.user.deleted_at" target="_blank" class="room__userlink"
                :href="consultation.doctor.link">Показать профиль</a>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    export default {
        name: "UserInfo",
        computed: {
            ...mapState([
                'consultation',
                'patient',
                'user'
            ]),
        },
    }
</script>

<style scoped>

</style>
